module.exports = __webpack_public_path__ + "static/career-ladies-party-187e0e1fdc3fd29f4278a3d1fc565d5f.png";